import { useState } from "react";
import { ButtonPrimary } from "../../../components/NewButtons";
import { MutatePackingItemDrawer } from "./MutatePackingItemDrawer";
import { useSearchParamsManipulation } from "../../../hooks/use-searchparams-manipulation";

export const MutatePackingItemSelector = () => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const { removeOption } = useSearchParamsManipulation();

  return (
    <div>
      <ButtonPrimary
        onClick={() => {
          removeOption();
          setModalOpen(true);
        }}
        type="button"
      >
        Create packing item
      </ButtonPrimary>
      <MutatePackingItemDrawer
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
      />
    </div>
  );
};
